<template>
  <v-row class="shrink elevation rounded-lg overflow-hidden" no-gutters>
    <div
      v-for="(segment, index) in filteredSegments"
      :key="index"
      :style="{
        'width': `${segment.percentage}%`,
        'border-left': index !== 0 ? `${spacingBetweenSegments}px solid white` : 0
      }"
      class="d-inline-block"
    >
      <v-progress-linear
        :height="height"
        value="100"
        :color="segment.progressColor"
      >
        <template v-if="showLabel" v-slot:default>
          <div :class="['d-flex align-center w-100 h-100', textAlign === 'start' ? 'justify-start ml-2' : 'justify-end']">
            <span
                class="caption mr-1"
                :style="{'color': segment.textColor ? segment.textColor : ''}"
            >
              {{ segment.value === undefined ? '' : segment.value ? segment.value : segment.percentage }}
            </span>
          </div>
        </template>
      </v-progress-linear>
    </div>
  </v-row>
</template>

<script>
import {computed} from "@vue/composition-api";

export default {
    name: 'ProgressBar',
    props: {
        // Segments example: [{label: '', value: '', percentage: 100, color: '', textColor: '', showAvatar: true}]
        segments: {
            type: Array,
            default: () => []
        },
        height: {
            type: Number,
            default: 24
        },
        showLabel: {
            type: Boolean,
            default: false,
        },
        spacingBetweenSegments: {
            type: Number,
            default: 1,
        },
        textAlign: {
            type: String,
            required: false,
            default: 'end'
        }
    },
    setup(props) {

        const filteredSegments = computed(() => {
            return props.segments.filter(s => s.percentage !== 0 && !isNaN(s.percentage))
        })

        return {
            filteredSegments
        }
    }
}
</script>

<style scoped lang="scss">
</style>

